import { WishlistContext } from "@magalu/ecomm-components/contexts/WishlistContext";
import { useUserInfo } from "@magalu/ecomm-components/hooks";
import React from "react";

type WishlistProviderProps = {
  children?: React.ReactNode;
};

const WishlistProvider: React.FC<WishlistProviderProps> = ({ children }) => {
  const { user } = useUserInfo();

  return (
    <WishlistContext
      values={{
        isLogged: user?.isLogged,
        storageOnly: true,
        useUnloggedWishlist: true,
        userId: user?.tempId as string,
      }}
    >
      {children}
    </WishlistContext>
  );
};

export default WishlistProvider;
